import PreviewSection from '../../PreviewSection'

export default function CostHTMLPreviewBaseSection() {}

CostHTMLPreviewBaseSection.prototype = new PreviewSection();

CostHTMLPreviewBaseSection.prototype.init = function( columnsStrategy )
{
    PreviewSection.prototype.init.call( this );
    this.columnsStrategy = columnsStrategy;
    return this;
};

CostHTMLPreviewBaseSection.prototype.addRowWithMainCell = function( tBody, mainCellText, mainCellClass, rowClass )
{
    var row = this.createRow( rowClass );
    this.addCell( row, mainCellText, mainCellClass );
    this.columnsStrategy.addDataCells( row );
    this.addRow( tBody, row );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/cost/CostHTMLPreviewBaseSection.js